import {FlowConfigInterface} from 'app/components/onboardingFlows/flows/common/FlowConfigInterface';
import NewDistrictMainPageFlow from 'app/components/onboardingFlows/flows/NewDistrictMainPageFlow';

const availableFlowsArray: FlowConfigInterface[] = [new NewDistrictMainPageFlow()];

const flows: FlowConfigInterface[] = availableFlowsArray;

const getFlows = (isAuthenticated: boolean, pathname: string): FlowConfigInterface[] => {
  const authMatchingFlows = !isAuthenticated ? flows.filter(flow => !flow.authProtected) : flows;
  return authMatchingFlows.filter((flow): flow is FlowConfigInterface => flow.isAllowedToDisplay(pathname));
};

export default getFlows;
